import React from "react";

function GameOver() {
	return (
		<div>
			<h1 style={{ fontSize: "10rem", color: "#e50914",padding:'1rem' }}>GAME OVER</h1>
		</div>
	);
}

export default GameOver;
